function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.67011 -9.91821e-05H14.3401C17.7301 -9.91821e-05 20.0001 2.3799 20.0001 5.9199V14.0909C20.0001 17.6199 17.7301 19.9999 14.3401 19.9999H5.67011C2.28011 19.9999 0.000106812 17.6199 0.000106812 14.0909V5.9199C0.000106812 2.3799 2.28011 -9.91821e-05 5.67011 -9.91821e-05ZM9.43011 12.9899L14.1801 8.2399C14.5201 7.8999 14.5201 7.3499 14.1801 6.9999C13.8401 6.6599 13.2801 6.6599 12.9401 6.9999L8.81011 11.1299L7.06011 9.3799C6.72011 9.0399 6.16011 9.0399 5.82011 9.3799C5.48011 9.7199 5.48011 10.2699 5.82011 10.6199L8.20011 12.9899C8.37011 13.1599 8.59011 13.2399 8.81011 13.2399C9.04011 13.2399 9.26011 13.1599 9.43011 12.9899Z",
  fill: "#C2C9D1"
});

function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9546ce48.svg";
export { ForwardRef as ReactComponent };